(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["botanical-set"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fit(root) {
      (root || document).querySelectorAll('.bot__ring-text').forEach(function (tp) {
        var target = parseFloat(tp.getAttribute('data-len'));
        if (!target || !tp.getComputedTextLength) return;
        var n = (tp.textContent || '').length;
        tp.removeAttribute('letter-spacing');
        var len = tp.getComputedTextLength();
        if (!n || !len) return;
        if (Math.abs(len - target) > 2) {
          tp.setAttribute('letter-spacing', (target - len) / n);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { fit(); });
    } else {
      fit();
    }
    window.addEventListener('load', function () { fit(); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { fit(); });
    }
    document.addEventListener('shopify:section:load', function (e) { fit(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sh-toggle]');
    if (!btn) return;
    var sh = btn.closest('.sh');
    var open = sh.classList.toggle('sh--drawer');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  (function () {
    function restore(card) {
      if (!card || !card.dataset.saved) return;
      var img = card.querySelector('.sh__card-img');
      var title = card.querySelector('.sh__card-title');
      img.src = card.dataset.src;
      if (card.dataset.srcset) img.setAttribute('srcset', card.dataset.srcset);
      if (title) title.textContent = card.dataset.title;
      card.setAttribute('href', card.dataset.href);
    }

    document.addEventListener('mouseover', function (e) {
      var item = e.target.closest('.sh__item--mega');
      if (!item) return;
      if (!item.dataset.pre) {
        item.dataset.pre = '1';
        item.querySelectorAll('[data-sh-img]').forEach(function (x) { new Image().src = x.dataset.shImg; });
      }
      var a = e.target.closest('[data-sh-img]');
      var card = item.querySelector('[data-sh-card]');
      if (!a || !card) return;
      var img = card.querySelector('.sh__card-img');
      var title = card.querySelector('.sh__card-title');
      if (!card.dataset.saved) {
        card.dataset.saved = '1';
        card.dataset.src = img.getAttribute('src');
        card.dataset.srcset = img.getAttribute('srcset') || '';
        card.dataset.href = card.getAttribute('href');
        card.dataset.title = title ? title.textContent : '';
      }
      img.removeAttribute('srcset');
      img.src = a.dataset.shImg;
      if (title) title.textContent = a.dataset.shTitle;
      card.setAttribute('href', a.getAttribute('href'));
    });

    document.addEventListener('mouseout', function (e) {
      var mega = e.target.closest ? e.target.closest('.sh__mega') : null;
      if (!mega || mega.contains(e.relatedTarget)) return;
      restore(mega.querySelector('[data-sh-card]'));
    });
  })();

  /* Sticky: görgetéskor az átlátszó fejléc fehér hátteret kap, hogy olvasható maradjon */
  (function () {
    function onScroll() {
      var scrolled = window.scrollY > 10;
      document.querySelectorAll('.sh--overlay').forEach(function (sh) {
        sh.classList.toggle('sh--scrolled', scrolled);
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();
  /* Nyelvválasztó legördülő: kattintás máshová bezárja */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.sh__dd[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["syssye-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function update(sec) {
      var track = sec.querySelector('.cat__track');
      var prev = sec.querySelector('[data-cat-dir="-1"]');
      var next = sec.querySelector('[data-cat-dir="1"]');
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    function init(root) {
      (root || document).querySelectorAll('.cat').forEach(function (sec) {
        var track = sec.querySelector('.cat__track');
        if (!track || track.dataset.bound) return;
        track.dataset.bound = '1';
        track.addEventListener('scroll', function () { update(sec); }, { passive: true });
        update(sec);
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cat-dir]');
      if (!btn) return;
      var sec = btn.closest('.cat');
      var track = sec.querySelector('.cat__track');
      var item = track.querySelector('.cat__item');
      if (!item) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = (item.getBoundingClientRect().width + gap) * 2;
      track.scrollBy({ left: step * parseInt(btn.dataset.catDir, 10), behavior: 'smooth' });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    window.addEventListener('resize', function () {
      document.querySelectorAll('.cat').forEach(update);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["syssye-club"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(stage) {
      if (stage.dataset.bound) return;
      stage.dataset.bound = '1';
      var raf = null, tx = 0, ty = 0;

      function apply() {
        raf = null;
        stage.style.setProperty('--cl-x', tx.toFixed(3));
        stage.style.setProperty('--cl-y', ty.toFixed(3));
      }

      stage.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        var r = stage.getBoundingClientRect();
        tx = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width - 0.5) * 2));
        ty = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height - 0.5) * 2));
        stage.classList.add('is-active');
        if (!raf) raf = requestAnimationFrame(apply);
      });

      stage.addEventListener('pointerleave', function () {
        tx = 0; ty = 0;
        stage.classList.remove('is-active');
        apply();
      });
    }

    function init(root) {
      (root || document).querySelectorAll('[data-cl-stage]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
